<template>
  <b-card>
    <div v-if="isLoading" class="text-center text-primary my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong> Wczytywanie...</strong>
    </div>

    <div v-else>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-2">
        <h4>Zwrot #{{ customerReturn.id }}</h4>
        <b-button :to="{ name: 'returns-index' }" variant="outline-primary">Wróć do listy</b-button>
      </div>

      <b-row>
        <b-col md="6">
          <h5 class="mb-1">Dane klienta</h5>
          <b-form-group label="Imię i nazwisko">
            <b-form-input :value="customerReturn.full_name" disabled />
          </b-form-group>
          <b-form-group label="Email">
            <b-form-input :value="customerReturn.email" disabled />
          </b-form-group>
          <b-form-group label="Telefon">
            <b-form-input :value="customerReturn.phone" disabled />
          </b-form-group>
          <b-form-group label="Adres">
            <b-form-input :value="address" disabled />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <h5 class="mb-1">Zwrot środków</h5>
          <b-form-group label="Metoda">
            <b-form-input :value="refundMethodLabel" disabled />
          </b-form-group>
          <b-form-group v-if="customerReturn.bank_account_number" label="Numer konta">
            <b-form-input :value="customerReturn.bank_account_number" disabled />
          </b-form-group>

          <h5 class="mt-2 mb-1">Status</h5>
          <b-form-group label="Status">
            <b-form-select v-model="statusForm.status" :options="statusOptions" />
          </b-form-group>
          <b-form-group label="Komentarz administratora">
            <b-form-text class="form-description">
             Po zmianie statusu zwrotu, klient otrzyma wiadomość e-mail z instrukcjami dotyczącymi dalszego procesu. Możesz tu dodać dodatkowe informacje lub komentarze, które będą pomocne dla klienta podczas realizacji zwrotu.
            </b-form-text>
            <b-form-textarea v-model="statusForm.admin_comment" rows="3" />
          </b-form-group>
          <b-button variant="primary" :disabled="isSaving" @click="saveStatus">
            {{ isSaving ? 'Zapisywanie...' : 'Zapisz status' }}
          </b-button>
        </b-col>
      </b-row>

      <h5 class="mt-3 mb-1">Zamówienie</h5>
      <b-row>
        <b-col md="4">
          <b-form-group label="Numer zamówienia">
            <b-form-input :value="customerReturn.order_id" disabled />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Wartość">
            <b-form-input :value="orderTotal" disabled />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Data zgłoszenia">
            <b-form-input :value="customerReturn.created_at" disabled />
          </b-form-group>
        </b-col>
      </b-row>

      <h5 class="mt-3 mb-1">Produkty</h5>
      <b-table responsive bordered striped :items="customerReturn.items" :fields="itemFields">
        <template #cell(product)="row">
          <div>{{ row.item.product.name }}</div>
          <small>{{ row.item.product.sku }}</small>
        </template>
        <template #cell(reason)="row">
          {{ row.item.reason.name }}
        </template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';
import { show, updateStatus } from '@/http/returns';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      customerReturn: {
        items: [],
        order: {},
      },
      statusForm: {
        status: 'new',
        admin_comment: '',
      },
      statusOptions: [
        { value: 'new', text: 'Nowe' },
        { value: 'in_review', text: 'Rozpatrywane' },
        { value: 'accepted', text: 'Zaakceptowane' },
        { value: 'completed', text: 'Zakończone' },
        { value: 'rejected', text: 'Odrzucone' },
      ],
      itemFields: [
        { key: 'product', label: 'Produkt' },
        { key: 'quantity', label: 'Ilość' },
        { key: 'reason', label: 'Powód' },
      ],
      isLoading: false,
      isSaving: false,
    };
  },

  computed: {
    address() {
      return `${this.customerReturn.address || ''}, ${this.customerReturn.zip_code || ''} ${this.customerReturn.city || ''}`;
    },
    refundMethodLabel() {
      return this.customerReturn.refund_method === 'bank_account' ? 'Zwrot na konto bankowe' : 'Oryginalna forma płatności';
    },
    orderTotal() {
      const value = this.customerReturn.order?.total_price || 0;
      return `${Number(value).toFixed(2)} PLN`;
    },
  },

  mounted() {
    this.fetchReturn();
  },

  methods: {
    async fetchReturn() {
      try {
        this.isLoading = true;
        const { data } = await show(this.$route.params.id);
        this.customerReturn = data.data;
        this.statusForm.status = this.customerReturn.status;
        this.statusForm.admin_comment = this.customerReturn.admin_comment;
      } catch (error) {
        this.showErrorNotification('Problem z pobraniem danych', 'Nie udało się pobrać szczegółów zwrotu.');
      } finally {
        this.isLoading = false;
      }
    },
    async saveStatus() {
      try {
        this.isSaving = true;
        const { data } = await updateStatus(this.customerReturn.id, this.statusForm);
        this.customerReturn = data.data;
        this.showSuccessNotification('Status zapisany', 'Status zwrotu został zaktualizowany.');
      } catch (error) {
        const message = error.response?.data?.message || 'Nie udało się zapisać statusu zwrotu.';
        this.showErrorNotification('Problem z zapisem', message);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<styles scoped lang="scss">
.form-description {
display: block;
margin: 0.5rem 0;
color: #6c757d;
font-size: 0.875rem;
}

</styles>